<div class="lib-heading">
    <div class="lib-heading__icon">
        <ng-content select="[icon]"></ng-content>
    </div>
    <div class="lib-heading__header">
        <ng-content select="[header]"></ng-content>
    </div>
    <div class="lib-heading__body">
        <ng-content select="[body]"></ng-content>
    </div>
</div>
